function setup (forms) {
    for (let i = 0; i < forms.length; i++) {
        const labels = [].slice.call(forms[i].getElementsByTagName('label'));
        labels.forEach((label) => {
            let input = label.parentNode.parentNode.getElementsByTagName('select')[0];

            if (input != null) {
                input.parentNode.insertBefore(label, input.nextSibling);
                input.classList.add('form-field-has-value');
            } else {
                if (input == null) input = label.parentNode.parentNode.getElementsByTagName('textarea')[0];
                if (input == null) input = label.parentNode.parentNode.getElementsByTagName('input')[0];
                if (input !== null) {
                    if (input.type !== 'file') {
                        input.parentNode.insertBefore(label, input.nextSibling);

                        // set flag if input is empty or not
                        // initially
                        if (input.value) {
                            input.classList.add('form-field-has-value');
                        }

                        // and on the fly
                        input.addEventListener('input', (e) => {
                            if (e.target.value) {
                                e.target.classList.add('form-field-has-value');
                            } else {
                                e.target.classList.remove('form-field-has-value');
                            }
                        });
                    };
                }
            }
        });
    }
}

// The setup method must be globally available because the ProductDownloads web part is using a BizForm in an UpdatePanel
function provideGlobal() {
    if (!window.FRFloatingLabels) {
        window.FRFloatingLabels = setup;
    }
}

export default {
    setup,
    provideGlobal
};
